import vsf, { definePage } from '@vs/vsf-boot';
import { Page } from '@vs/vsf-kit';
import React from 'react';

const AccountManagement = (props) => {
  return <Page title="AccountManagement"></Page>;
};

export default definePage(AccountManagement);
